export function formatCurrency(val) {
  const n = parseFloat(val) || 0
  if (n >= 1000) return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 })
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatDate(d, opts = {}) {
  if (!d) return ''
  try { return new Date(d + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', ...opts }) }
  catch { return d }
}

export function formatDateTime(d) {
  if (!d) return ''
  try { return new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) }
  catch { return d }
}

export function timeAgo(d) {
  if (!d) return ''
  const diff = Date.now() - new Date(d).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  return `${days}d ago`
}

export function statusColor(status) {
  const map = { new: 'blue', contacted: 'cyan', qualified: 'purple', proposal_sent: 'yellow',
    negotiation: 'orange', closed_won: 'green', closed_lost: 'red', tentative: 'yellow',
    definite: 'green', cancelled: 'red', pending: 'yellow', completed: 'green', in_progress: 'cyan' }
  return map[status] || 'secondary'
}

export function priorityColor(p) {
  return p === 'high' ? 'red' : p === 'medium' ? 'yellow' : 'secondary'
}

export const STAGES = [
  { key: 'discovery', label: 'Discovery' },
  { key: 'qualification', label: 'Qualification' },
  { key: 'proposal', label: 'Proposal' },
  { key: 'negotiation', label: 'Negotiation' },
  { key: 'closed_won', label: 'Won' },
  { key: 'closed_lost', label: 'Lost' },
]
